import type { FormLead, FormLeadPayload } from '@alexanderathoodly/data-models'
import { apiClient } from '~/utils/requests'

export function createOrUpdateFormLead(
	leadID: string | null,
	data: FormLeadPayload
): Promise<FormLead> {
	if (leadID) {
		return apiClient.updateFormLead(leadID, data)
	} else {
		return apiClient.createFormLead(data)
	}
}
